export const colours = {
  blackOverlay: "rgba(0, 0, 0, 0.5)",
  whiteOverlay: "rgba(255, 255, 255, 0.1)",
};
